import api from './index'
//
let exports = {}

// ----------------- 财务税码 --------------

// 获取财务税码列表
exports.getFiscalTaxMarkPageList = function (data, callback) {
    api.post('/fiscal/biz/tax/mark/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getSyncFiscalTaxMarkPageList = function (data, callback) {
    api.post('/fiscal/biz/tax/mark/list/get')
    .data(data)
    .sync(true)
    .done(callback)
    .go()
};

// ------------------ 实体公司系统业务状态 --------------------------
exports.getRealComSysBizStateByUk = function (data, callback) {
    api.post('/fiscal/biz/real/com/sys/biz/state/get')
    .data(data)
    .done(callback)
    .go()
};

exports.getRealComSysBizStateListByFilter = function (data, callback) {
    api.post('/fiscal/biz/real/com/sys/biz/state/page/list/get')
    .data(data)
    .done(callback)
    .go()
};

export default exports



//////////////////
// WEBPACK FOOTER
// ./src/api/fiscalBiz.js
// module id = 50
// module chunks = 0